/**
 * Formatuje czas w sekundach do formatu MM:SS
 * @param {number} seconds - czas w sekundach do sformatowania
 * @returns {string} - sformatowany czas w formacie MM:SS
 */
export const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};

/**
 * Konwertuje czas z minut do sekund
 * @param {number} minutes - czas w minutach
 * @returns {number} - czas w sekundach
 */
export const minutesToSeconds = (minutes) => {
    return minutes * 60;
};

/**
 * Konwertuje czas z sekund do minut
 * @param {number} seconds - czas w sekundach
 * @returns {number} - czas w minutach (zaokrąglony)
 */
export const secondsToMinutes = (seconds) => {
    return Math.round(seconds / 60);
};